// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"component-space"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M21 4H3V10H21V4Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M21 14H3V20H21V14Z"}}]},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M21 4H3V10H21V4Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M21 14H3V20H21V14Z","strokeWidth":"props.strokeWidth"}}]}]}]};

const ComponentSpaceIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'component-space',
    ref,
    icon: element,
  },
));

ComponentSpaceIcon.displayName = 'ComponentSpaceIcon';

export default ComponentSpaceIcon;
